/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 1/12/2021
 */
import FormElementType from "@/core/modules/coach/Resources/Forms/model/FormElements/FormElementType";
import BaseSmartFormElement from "@/core/modules/coach/Resources/Forms/model/FormElements/Smart/BaseSmartFormElement";
import {formTriggerEmail} from "@/utils/helpers";

export default class FormElementEmailAddress extends BaseSmartFormElement {


	constructor(title, options = {}) {
		super(FormElementType.EMAIL_ADDRESS, title, {required: true, ...options});
	}

	resetElement() {
		super.resetElement();
		this.title = "Email Address"
		this.isRequired = true
		this.showRequiredSwitch = false
		this.placeholder = "Email Address Question Text"
		// this.disableEditing = true
		// this.specialQuestionDescription = "email address"
	}

	getSpecialQuestionDescription(){
		return "email address"
	}

	getSmartFiledPropertyName(){
		return "email"
	}


	getValidateRules(){
		return formTriggerEmail()
	}


}
